import { createFileRoute } from '@tanstack/react-router';
import { EntrepriseTab } from '@/features/account/entreprise/EntrepriseTab';

export const Route = createFileRoute('/account/entreprise')({
  component: EntrepriseTab,
});
